export const SOLUTION_ID={
    'QUINDE':1,
    'ALPAQQA':2,
    'NUNA':3,
    'MIQO':4,
    'QREATIVEE':5,
    'ADMINISTRATION':6
}